import axios from 'axios';
import { HttpService } from './http.service';

const TOKEN_KEY = 'standby_token';

export function getStoredToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setStoredToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearStoredToken() {
  localStorage.removeItem(TOKEN_KEY);
}

const axiosInstance = axios.create({
  withCredentials: true
});

axiosInstance.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export class HttpFactoryService {
  createHttpService(): HttpService {
    return new HttpService(axiosInstance);
  }
}
